<div class="absolute inset-0 flex items-center justify-center">
  <mat-spinner *ngIf="!(GTMloaded$ | async)" diameter="50"></mat-spinner>
</div>